import React from "react";
import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import {NodeViewContent} from "@tiptap/react";
import type {NodeViewProps} from "@tiptap/react";
import PrintoutBlockShell from "../shared/PrintoutBlockShell";
import {normalizePrintoutContainerSpaceAbove} from "./printoutContainerOptions";

const PrintoutContainerNodeView = (props: NodeViewProps) => {
    const editable = props.editor.isEditable;

    return (
        <PrintoutBlockShell
            {...props}
            activateOnContentSelection
            allowEditableContent={editable}
            blockType="printoutContainer"
            dataAttributes={{
                "data-printout-container-space-above": String(normalizePrintoutContainerSpaceAbove(props.node.attrs.spaceAboveMm)),
            }}
            editableContentSelector=".printout-container-column"
            icon={<ViewWeekOutlinedIcon fontSize="small"/>}
            label="Container"
        >
            <NodeViewContent
                as="div"
                className="printout-container-columns"
                data-printout-container-separators={String(props.node.attrs.columnSeparators === true)}
            />
        </PrintoutBlockShell>
    );
};

export default PrintoutContainerNodeView;
